const Schedule = {

    // FIELDS
    "premise": "Premise",
    "zone": "Zone",
    "level": "Level",
    "asset": "Type",
    "asset_inward": "Asset",
    "date": "Date",
    "priority": "Priority",
    "frequency": "Frequency",
    "search": "Search",
    "date_from": "Date From",
    "date_to": "Date To",

    // PRIORITY
    "priority_low": "Low",
    "priority_medium": "Medium",
    "priority_high": "High",
    "priority_critical": "Critical",

    // FREQUENCY
    "frequency_one_time": "One Time",
    "frequency_daily": "Daily",
    "frequency_weekly": "Weekly",
    "frequency_monthly": "Monthly",
    "frequency_quarterly": "Quarterly",
    "frequency_half_yearly": "Half Yearly",
    "frequency_yearly": "Yearly",

    // PAGE HEADER
    "schedule": "Schedule",

    // ERROR
    "error_premise": "Select Premise",
    "error_zone": "Select Zone",
    "error_level": "Select Level",
    "error_asset": "Select Type",
    "error_asset_inward": "Select Asset",
    "error_date": "Select Date",
    "error_priority": "Select Priority",
    "error_frequency": "Select Frequency",

    // TABLE HEADER
    "table_premise": "PREMISE",
    "table_zone": "ZONE",
    "table_level": "LEVEL",
    "table_asset": "TYPE",
    "table_asset_inward": "ASSET",
    "table_date": "DATE",
    "table_priority": "PRIORITY",
    "table_frequency": "FREQUENCY",

}

export default Schedule;